import React from 'react'

import { Card, LineItem } from '@/components'
import { RentalApplication } from '@/types/RentalApplication'

import { occupantData } from './MoveIn.data'

export function OccupantSection({ rentalApplication }: { rentalApplication: RentalApplication }) {
  const occupants = rentalApplication.occupants || []

  return (
    <>
      {occupants.length > 0 && (
        <>
          {occupants.map((occ, _index) => {
            return (
              <Card cardClassName="mb-4" headerText={`Occupant ${_index + 1}`} key={_index} minimizable={true}>
                <div className="flex w-full flex-col px-4">
                  {occupantData.map(({ label, field, tag }, index) => {
                    return (
                      <LineItem
                        key={index}
                        label={label}
                        last={index === occupantData.length - 1}
                        tag={tag}
                        value={occ[field]}
                      />
                    )
                  })}
                </div>
              </Card>
            )
          })}
        </>
      )}
    </>
  )
}
